<template>
    <div class="works-list-wrapper">
        <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
        <div v-else>
            <div class="works-list">
                <div class="works-list-item" v-for="(item, index) in list" :key="type + index">
                    <Card :data="item" @openDetail="openDetail" @openUserDetail="openUserDetail"></Card>
                </div>
            </div>

            <div class="loading" v-show="scrollLoading">
                <i class="el-icon-loading"></i>
            </div>
            <!-- 分页 -->
            <div class="works-list__pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :current-page="pageNum"
                    :total="total"
                    @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { openWindow } from '@/utils/utils';
import { getWorkList, getWorkTabs } from '@/api/works';
import Card from '@/views/components/Card';
import EmptyPage from '@/components/EmptyPage';

export default {
    name: 'WorksList',
    components: {
        Card,
        EmptyPage
    },
    inject: ['backTop'],
    props: {
        type: {
            type: [String, Number],
            default: 'all'
        }
    },
    data: () => ({
        loading: true,
        scrollLoading: false,
        total: 0,
        pageSize: 40,
        pageNum: 1,
        pages: 1,
        list: [],
        categoryList: [
            { label: '原创', value: 3 },
            { label: '转载', value: 1 },
            { label: '自译', value: 2 }
        ]
    }),
    computed: {
        ...mapState('app', ['scrollStatus'])
    },
    watch: {
        type: {
            handler() {
                this.loading = true;
                this.list = [];
                this.initPageParams();
                this.getWorkList();
            },
            immediate:true
        },
        // scrollStatus() {
        //     if (!this.scrollLoading) {
        //         this.scroll();
        //     }
        // }
    },
    mounted() {
        // this.initPageParams();
        this.getLabelList();
        // this.getWorkList();
    },
    methods: {
        getLabelList() {
            // 获取作品标签
            getWorkTabs({
                type: 3
            }).then(({ data }) => {
                const options = data.map(({ id, name }) => {
                    return {
                        label: name,
                        value: id
                    };
                });
                this.categoryList = [
                    ...options
                ];
            });
        },
        initPageParams() {
            this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
            this.pageSize = 40;
            this.total = 0;
            this.pages = 1;
        },
        handlePageChange(pageNum) {
            sessionStorage.setItem(this.$route.path, pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getWorkList();
        },
        async getWorkList() {
            try {
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                };
                if (this.type !== 'all') {
                    params.flId = this.type;
                }
                const { code, data } = await getWorkList(params);
                if (code === 0) {
                    const add = data.result.map(item => {
                        let category = null;
                        this.categoryList.forEach(a => {
                            if (a.value === item.labelId) {
                                category = a.label;
                                return;
                            }
                        });
                        return {
                            id: item.id,
                            title: item.title,
                            follow: item.viewCount,
                            collect: item.collectionCount,
                            like: item.zanCount,
                            category,
                            image: item.logo,
                            userId: item.user && item.user.id,
                            name: item.user && item.user.name,
                            avatar: item.user && item.user.imageAddress,
                            recommend: item.recommend
                        };
                    });
                    // this.list = [...this.list, ...add];
                    this.list = add || [];
                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
                this.scrollLoading = false;
            }
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getWorkList();
        },
        openDetail(data) {
            const { id } = data;
            openWindow('/#/works/detail/' + id);
        },
        openUserDetail(id) {
            if (!id) return;
            this.$router.push({
                name: 'User',
                params: { id }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.works-list {
    padding-top: 20px;

    &-item {
        display: inline-block;
        width: 300px;
        margin-right: 25px;
        margin-top: 0;

        &:nth-child(5n + 5) {
            margin-right: 0;
        }

        &:nth-child(n + 6) {
            margin-top: 20px;
        }
    }
    &__pagination {
        margin-top: 45px;
        padding-bottom: 45px;
        text-align: center;
    }
}

.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}

// 小屏
@include mq($small) {
    .works-list {
        padding-top: 15px;

        &-item {
            width: 225px;
            margin-right: 15px;
            margin-top: 0;

            &:nth-child(5n + 5) {
                margin-right: 0;
            }

            &:nth-child(n + 6) {
                margin-top: 15px;
            }
        }
        &__pagination {
            margin-top: 30px;
            text-align: center;
        }
    }
}
</style>
